import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import { APP_VERSION } from '../../config/brand';
import { Icon } from '../ui';
import { useVerlaufMerken, useScrollstandMerken } from '../ZurueckLink';
import './Layout.css';

const LEISTE_KEY = 'hp.seitenleiste';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  // Ab Tablet-Breite standardmäßig ausgeklappt, außer der Nutzer hat eingeklappt (gemerkt);
  // auf dem Handy immer zu – dort ist die Leiste ein Overlay.
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    if (typeof window === 'undefined' || window.innerWidth < 769) return false;
    try { return localStorage.getItem(LEISTE_KEY) !== 'eingeklappt'; } catch { return true; }
  });

  // Das Umschalten ändert die Inhaltsbreite; Karten (Leaflet) messen nach der Transition neu.
  const toggleSidebar = () => {
    setSidebarOpen(o => {
      if (window.innerWidth >= 769) {
        try { localStorage.setItem(LEISTE_KEY, o ? 'eingeklappt' : 'offen'); } catch { /* egal */ }
      }
      return !o;
    });
    window.setTimeout(() => window.dispatchEvent(new Event('resize')), 320);
  };

  // Die Suche sitzt oben im Dashboard; Strg/⌘ + K springt von überall dorthin und setzt den Fokus.
  const navigate = useNavigate();
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        navigate('/dashboard', { state: { suche: Date.now() } });
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [navigate]);

  useVerlaufMerken();
  useScrollstandMerken();

  return (
    <div className="layout">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} onToggle={toggleSidebar} />
      {/* Handy: die Leiste ist ein Overlay – dieser Knopf öffnet sie. Ab Tablet-Breite ist sie immer
          da (ein- oder ausgeklappt), eine Kopfzeile braucht es nicht. */}
      {!sidebarOpen && (
        <button className="menue-knopf" onClick={toggleSidebar} aria-label="Menü öffnen">
          <Icon.Menue className="h-5 w-5" />
        </button>
      )}
      <div className={`main-content ${sidebarOpen ? 'with-sidebar' : ''}`}>
        <main className="main-body">
          {children}
        </main>
        <div className="version-badge">v{APP_VERSION}</div>
      </div>
    </div>
  );
};

export default Layout;
